import { states } from './states'

export enum DocusignFieldTabLabel {
  fullName = 'fullName',
  email = 'email',
  address = 'address',
  city = 'city',
  state = 'state',
  zipcode = 'zipcode',
  cityStateZipcode = 'cityStateZipcode',
  phoneNumber = 'phoneNumber',
  phoneNumberHome = 'phoneNumberHome',
  driverLicenseNumber = 'driverLicenseNumber',
  yearsOfExperience = 'yearsOfExperience',
  ssn = 'ssn',
  tin = 'tin',
  fein = 'fein',
  dob = 'dob',
  beneficiary = 'beneficiary',
  beneficiaryRelationship = 'beneficiaryRelationship',
  insuranceCarrier = 'insuranceCarrier',
  otherInsurancePlan = 'otherInsurancePlan',
  eSignatureAck = 'eSignatureAck',
  businessName = 'businessName',
  ein = 'ein',
  vehicleYear = 'vehicleYear',
  vehicleMake = 'vehicleMake',
  vehicleModel = 'vehicleModel',
  vehicleVIN = 'vehicleVIN',
  vehicleLicensePlate = 'vehicleLicensePlate',
  vehicleYear2 = 'vehicleYear2',
  vehicleMake2 = 'vehicleMake2',
  vehicleModel2 = 'vehicleModel2',
  vehicleVIN2 = 'vehicleVIN2',
  vehicleLicensePlate2 = 'vehicleLicensePlate2',
  vehicleYear3 = 'vehicleYear3',
  vehicleMake3 = 'vehicleMake3',
  vehicleModel3 = 'vehicleModel3',
  vehicleVIN3 = 'vehicleVIN3',
  vehicleLicensePlate3 = 'vehicleLicensePlate3',
  taxClassificationType = 'taxClassificationType',
  llcType = 'llcType',
  exemptPayeeCode = 'exemptPayeeCode',
  exemptionFatcaCode = 'exemptionFatcaCode',
  mmsOregonAddress = 'mmsOregonAddress',
  otherForeignPartners = 'otherForeignPartners',
  otherTaxClassification = 'otherTaxClassification',
  taxId = 'taxId',
  companyTitle = 'companyTitle',
}

export const DocusignFieldNames = {
  [DocusignFieldTabLabel.phoneNumber]: 'Phone number',
  [DocusignFieldTabLabel.phoneNumberHome]: 'Home Phone number',
  [DocusignFieldTabLabel.email]: 'Email address',
  [DocusignFieldTabLabel.fullName]: 'Full name',
  [DocusignFieldTabLabel.address]: 'Address',
  [DocusignFieldTabLabel.city]: 'City',
  [DocusignFieldTabLabel.state]: 'State',
  [DocusignFieldTabLabel.zipcode]: 'ZIP code',
  [DocusignFieldTabLabel.cityStateZipcode]: 'City, state, and ZIP code',
  [DocusignFieldTabLabel.ssn]: 'SSN',
  [DocusignFieldTabLabel.tin]: 'Taxpayer ID number',
  [DocusignFieldTabLabel.fein]: 'Federal employer ID number',
  [DocusignFieldTabLabel.dob]: 'Your Date of Birth',
  [DocusignFieldTabLabel.beneficiary]:
    'Beneficiary (This info will be used for your Occupational Accident Insurance)',
  [DocusignFieldTabLabel.beneficiaryRelationship]:
    'Relationship to Beneficiary (This info will be used for your Occupational Accident Insurance)',
  [DocusignFieldTabLabel.insuranceCarrier]: 'If Yes, name of insurance carrier',
  [DocusignFieldTabLabel.otherInsurancePlan]:
    'Are you covered under any other medical and/or disability insurance plan?',
  [DocusignFieldTabLabel.eSignatureAck]: 'Electronic signature acknowledgement',
  [DocusignFieldTabLabel.businessName]: 'Business entity name',
  [DocusignFieldTabLabel.ein]: 'EIN',
  [DocusignFieldTabLabel.vehicleYear]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.vehicleYear2]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake2]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel2]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN2]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate2]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.vehicleYear3]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake3]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel3]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN3]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate3]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.taxClassificationType]:
    'Tax Classification (This info will be used for the W9 form)',
  [DocusignFieldTabLabel.llcType]: 'LLC (If selected, you must select one of the following)',
  [DocusignFieldTabLabel.exemptPayeeCode]:
    'Exempt payee code, if any (This info will be used for the W9 form and is optional, can leave blank)',
  [DocusignFieldTabLabel.exemptionFatcaCode]:
    'Exemption from Foreign Account Tax Compliance Act (FATCA) reporting code, if any (This info will be used for the W9 form and is optional, can leave blank)',
  [DocusignFieldTabLabel.mmsOregonAddress]: '',
  [DocusignFieldTabLabel.driverLicenseNumber]: "Driver's License Number",
  [DocusignFieldTabLabel.yearsOfExperience]: 'Years of Experience',
  [DocusignFieldTabLabel.otherForeignPartners]:
    'If you selected “Partnership” or “Trust/estate,” or checked “LLC” and entered “P” as its tax classification above, AND you are providing this form to a partnership, trust, or estate in which you have an ownership interest, check this box if you have any foreign partners, owners, or beneficiaries. (otherwise leave unchecked)',
  [DocusignFieldTabLabel.otherTaxClassification]: 'Other Tax Classification',
  [DocusignFieldTabLabel.taxId]: 'Tax ID',
  [DocusignFieldTabLabel.companyTitle]: 'Company Title',
}

export enum DocusignSectionTitle {
  personalInformation = 'personalInformation',
  identificationLegalDocuments = 'identificationLegalDocuments',
  addressLocationInformation = 'addressLocationInformation',
  businessTaxInformation = 'businessTaxInformation',
  insuranceBeneficiaryDetails = 'insuranceBeneficiaryDetails',
  primaryVehicleInformation = 'primaryVehicleInformation',
  additionalVehicleInformation1 = 'additionalVehicleInformation1',
  additionalVehicleInformation2 = 'additionalVehicleInformation2',
  additionalInformation = 'additionalInformation',
}

export const docusignSectionsTitleMap = {
  [DocusignSectionTitle.personalInformation]: 'Personal Information',
  [DocusignSectionTitle.identificationLegalDocuments]: 'Identification & Legal Documents',
  [DocusignSectionTitle.addressLocationInformation]: 'Address information',
  [DocusignSectionTitle.businessTaxInformation]: 'Business & Tax Information',
  [DocusignSectionTitle.insuranceBeneficiaryDetails]: 'Insurance & Beneficiary Details',
  [DocusignSectionTitle.primaryVehicleInformation]: 'Primary Vehicle Information',
  [DocusignSectionTitle.additionalVehicleInformation1]: 'Additional Vehicle Information',
  [DocusignSectionTitle.additionalVehicleInformation2]: 'Additional Vehicle Information',
  [DocusignSectionTitle.additionalInformation]: 'Additional Information',
}

export const docusignSectionsMap: Record<DocusignSectionTitle, DocusignFieldTabLabel[]> = {
  [DocusignSectionTitle.personalInformation]: [
    DocusignFieldTabLabel.fullName,
    DocusignFieldTabLabel.email,
    DocusignFieldTabLabel.dob,
    DocusignFieldTabLabel.phoneNumber,
    DocusignFieldTabLabel.phoneNumberHome,
  ],
  [DocusignSectionTitle.addressLocationInformation]: [
    DocusignFieldTabLabel.address,
    DocusignFieldTabLabel.city,
    DocusignFieldTabLabel.state,
    DocusignFieldTabLabel.zipcode,
    DocusignFieldTabLabel.cityStateZipcode,
  ],
  [DocusignSectionTitle.identificationLegalDocuments]: [
    DocusignFieldTabLabel.driverLicenseNumber,
    DocusignFieldTabLabel.yearsOfExperience,
    DocusignFieldTabLabel.ssn,
    DocusignFieldTabLabel.tin,
    DocusignFieldTabLabel.fein,
    DocusignFieldTabLabel.ein,
    DocusignFieldTabLabel.taxId,
  ],
  [DocusignSectionTitle.businessTaxInformation]: [
    DocusignFieldTabLabel.businessName,
    DocusignFieldTabLabel.companyTitle,
    DocusignFieldTabLabel.taxClassificationType,
    DocusignFieldTabLabel.otherTaxClassification,
    DocusignFieldTabLabel.llcType,
    DocusignFieldTabLabel.otherForeignPartners,
    DocusignFieldTabLabel.exemptPayeeCode,
    DocusignFieldTabLabel.exemptionFatcaCode,
  ],
  [DocusignSectionTitle.insuranceBeneficiaryDetails]: [
    DocusignFieldTabLabel.beneficiary,
    DocusignFieldTabLabel.beneficiaryRelationship,
    DocusignFieldTabLabel.otherInsurancePlan,
    DocusignFieldTabLabel.insuranceCarrier,
  ],
  [DocusignSectionTitle.primaryVehicleInformation]: [
    DocusignFieldTabLabel.vehicleYear,
    DocusignFieldTabLabel.vehicleMake,
    DocusignFieldTabLabel.vehicleModel,
    DocusignFieldTabLabel.vehicleVIN,
    DocusignFieldTabLabel.vehicleLicensePlate,
  ],
  [DocusignSectionTitle.additionalVehicleInformation1]: [
    DocusignFieldTabLabel.vehicleYear2,
    DocusignFieldTabLabel.vehicleMake2,
    DocusignFieldTabLabel.vehicleModel2,
    DocusignFieldTabLabel.vehicleVIN2,
    DocusignFieldTabLabel.vehicleLicensePlate2,
  ],
  [DocusignSectionTitle.additionalVehicleInformation2]: [
    DocusignFieldTabLabel.vehicleYear3,
    DocusignFieldTabLabel.vehicleMake3,
    DocusignFieldTabLabel.vehicleModel3,
    DocusignFieldTabLabel.vehicleVIN3,
    DocusignFieldTabLabel.vehicleLicensePlate3,
  ],
  [DocusignSectionTitle.additionalInformation]: [DocusignFieldTabLabel.eSignatureAck],
}

export const DocusignFieldPlaceholders = {
  [DocusignFieldTabLabel.phoneNumber]: 'Enter phone number',
  [DocusignFieldTabLabel.phoneNumberHome]: 'Enter home phone number',
  [DocusignFieldTabLabel.email]: 'Enter email address',
  [DocusignFieldTabLabel.fullName]: 'Enter full name',
  [DocusignFieldTabLabel.address]: 'Enter address (number, street, and apt. or suite no.)',
  [DocusignFieldTabLabel.city]: 'Enter city',
  [DocusignFieldTabLabel.state]: 'Enter state',
  [DocusignFieldTabLabel.zipcode]: 'Enter ZIP code',
  [DocusignFieldTabLabel.cityStateZipcode]: 'Enter city, state, and ZIP code',
  [DocusignFieldTabLabel.ssn]: 'Enter SSN',
  [DocusignFieldTabLabel.tin]: 'Enter taxpayer ID number',
  [DocusignFieldTabLabel.fein]: 'Enter federal employer ID number',
  [DocusignFieldTabLabel.dob]: 'Enter your date of birth',
  [DocusignFieldTabLabel.beneficiary]: 'Enter beneficiary',
  [DocusignFieldTabLabel.beneficiaryRelationship]: 'Enter relationship to beneficiary',
  [DocusignFieldTabLabel.insuranceCarrier]: 'Enter insurance carrier',
  [DocusignFieldTabLabel.otherInsurancePlan]: '',
  [DocusignFieldTabLabel.eSignatureAck]: '',
  [DocusignFieldTabLabel.businessName]: 'Enter business entity name',
  [DocusignFieldTabLabel.ein]: 'Enter EIN',
  [DocusignFieldTabLabel.vehicleYear]: 'Enter vehicle year',
  [DocusignFieldTabLabel.vehicleMake]: 'Enter vehicle make',
  [DocusignFieldTabLabel.vehicleModel]: 'Enter vehicle model',
  [DocusignFieldTabLabel.vehicleVIN]: 'Enter vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate]: 'Enter vehicle license plate',
  [DocusignFieldTabLabel.vehicleYear2]: 'Enter additional vehicle year',
  [DocusignFieldTabLabel.vehicleMake2]: 'Enter additional vehicle make',
  [DocusignFieldTabLabel.vehicleModel2]: 'Enter additional vehicle model',
  [DocusignFieldTabLabel.vehicleVIN2]: 'Enter additional vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate2]: 'Enter additional vehicle license plate',
  [DocusignFieldTabLabel.vehicleYear3]: 'Enter additional vehicle year',
  [DocusignFieldTabLabel.vehicleMake3]: 'Enter additional vehicle make',
  [DocusignFieldTabLabel.vehicleModel3]: 'Enter additional vehicle model',
  [DocusignFieldTabLabel.vehicleVIN3]: 'Enter additional vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate3]: 'Enter additional vehicle license plate',
  [DocusignFieldTabLabel.taxClassificationType]: '',
  [DocusignFieldTabLabel.llcType]: 'Select LLC type',
  [DocusignFieldTabLabel.exemptPayeeCode]: 'Exempt payee code (if any)',
  [DocusignFieldTabLabel.exemptionFatcaCode]:
    'Exemption from Foreign Account Tax Compliance Act (FATCA) reporting code (if any)',
  [DocusignFieldTabLabel.mmsOregonAddress]: '',
  [DocusignFieldTabLabel.driverLicenseNumber]: 'Enter driver license number',
  [DocusignFieldTabLabel.yearsOfExperience]: 'Enter years of experience',
  [DocusignFieldTabLabel.otherForeignPartners]: '',
  [DocusignFieldTabLabel.otherTaxClassification]: 'Enter other tax classification',
  [DocusignFieldTabLabel.taxId]: 'Enter tax ID',
  [DocusignFieldTabLabel.companyTitle]: 'Enter company title',
}

export const llcTypeOptions = [
  { value: 'C', label: 'C corporation' },
  { value: 'S', label: 'S corporation' },
  { value: 'P', label: 'Partnership' },
]

export enum TaxClassificationType {
  Individual = 'individual',
  CCorp = 'cCorp',
  SCorp = 'sCorp',
  Partnership = 'partnership',
  Trust = 'trust',
  Llc = 'llc',
  Other = 'other',
}

export const DocusignFieldSelectOptions: any = {
  [DocusignFieldTabLabel.state]: states,
  [DocusignFieldTabLabel.llcType]: llcTypeOptions,
}

export const DocusignTaxClassificationLabelMap: { [key in TaxClassificationType]: string } = {
  [TaxClassificationType.Individual]: 'Individual/sole proprietor',
  [TaxClassificationType.CCorp]: 'C corporation',
  [TaxClassificationType.SCorp]: 'S corporation',
  [TaxClassificationType.Partnership]: 'Partnership',
  [TaxClassificationType.Trust]: 'Trust/estate',
  [TaxClassificationType.Llc]: 'LLC',
  [TaxClassificationType.Other]: 'Other',
}
